<template>
  <v-container
    class="
      d-flex flex-column gap-2
      px-0
    "
  >
    <template v-for="(filter, index) in filters">
      <label v-if="filter.type === 'select'" :key="`${filter.key}-select`" class="d-flex flex-column gap-1">
        <span class="text--secondary caption font-weight-bold">{{ filter.label }}</span>
        <v-select
          :value="activeFilters[filter.key]"
          :items="filter.items"
          v-bind="filter.itemText ? { 'item-text': filter.itemText, 'item-value': filter.itemValue } : {}"
          outlined
          dense
          hide-details
          color="third"
          item-color="third"
          class="rounded-lg body-2"
          @input="updateFilter(filter.key, $event)"
        />
      </label>
      <template v-else-if="filter.type === 'checkbox'" >
        <p v-if="index === filters.findIndex(f => f.type === 'checkbox')" class="text--secondary caption font-weight-bold mb-0">Filtres intelligents</p>
        <section class="d-flex align-center gap-1">
          <v-checkbox
            :id="`${filter.key}-checkbox`"
            :input-value="activeFilters[filter.key]"
            :key="`${filter.key}-checkbox`"
            dense
            hide-details
            color="third"
            class="mt-0 pt-0"
            :ripple="false"
            @change="updateFilter(filter.key, $event)"
          />
          <label :for="`${filter.key}-checkbox`" class="caption font-weight-bold pointer">{{ filter.label }}</label>
        </section>
      </template>
    </template>
  </v-container>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import store from '@/store';
import { getReferenceLabel } from '@/helpers/utils';

export default {
  name: 'HorsesFiltersPanel',
  props: {
    horses: {
      type: Array,
      required: true
    }
  },
  setup (props) {
    const availabilitiesList = ref([
      { label: 'Tous', value: null },
      { label: 'Disponible', value: 'available' },
      { label: 'Indisponible (soins, absence, repos, etc)', value: 'unavailable' }
    ])

    const horseTypeList = computed(() => {
      const types = [];
      props.horses.map(horse => {
        if (!types.some(type => type.value === horse.horse_type)) {
          types.push({ label: getReferenceLabel('equestrianType', horse.horse_type), value: horse.horse_type });
        }
      });
      return [
        { label: 'Tous', value: null },
        ...types.sort((a, b) => (a.label || '').localeCompare(b.label || ''))
      ];
    });

    const horseCategoriesList = computed(() => {
      const categories = [];
      props.horses.map(horse => {
        if (!categories.some(category => category.value === horse.horse_category)) {
          categories.push({ label: getReferenceLabel('equestrianCategory', horse.horse_category), value: horse.horse_category });
        }
      });
      return [
        { label: 'Toutes', value: null },
        ...categories.sort((a, b) => (a.label || '').localeCompare(b.label || ''))
      ];
    });

    const filters = computed(() => ([
      { key: 'availability', type: 'select', label: 'Disponibilité', items: availabilitiesList.value, itemText: 'label', itemValue: 'value' },
      { key: 'horseType', type: 'select', label: "Type d'équidé", items: horseTypeList.value, itemText: 'label', itemValue: 'value' },
      { key: 'horseCategory', type: 'select', label: 'Catégorie', items: horseCategoriesList.value, itemText: 'label', itemValue: 'value' },
      { key: 'unassignedHorses', type: 'checkbox', label: 'Chevaux non affectés' },
      { key: 'unusedRides', type: 'checkbox', label: 'Chevaux sans cavalier (Affectés uniquement à la reprise)' },
      { key: 'presentHorses', type: 'checkbox', label: 'Afficher uniquement les chevaux présents' },
    ]));

    const activeFilters = computed(() => store.state.horsesFilters?.active || {});

    const updateFilter = (key, value) => {
      store.commit('horsesFilters/setFilters', { key, value });
    };

    return {
      filters,
      activeFilters,
      updateFilter
    };
  }
};
</script>
